export const CHANGE_EDITOR_FOCUS = 'editor/CHANGE_EDITOR_FOCUS'
export const SET_EDITOR_MODE = 'editor/SET_EDITOR_MODE'
export const UPDATE_EDITOR_VISIBILITY = 'editor/UPDATE_EDITOR_VISIBILITY'
export const UPDATE_EDITOR_PINNED = 'editor/UPDATE_EDITOR_PINNED'
